export default {
  DIAGNOSTIC_PENDING: 'DIAGNOSTIC_PENDING',
  DIAGNOSTIC_COMPLETE: 'DIAGNOSTIC_COMPLETE',
  DIAGNOSTIC_ERROR: 'DIAGNOSTIC_ERROR',
}